<i18n
  src="@/locales/components/views/packing_house/production/uniq_final_packing_list/show_container/tabs/packages.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/package.yml" lang="yaml"></i18n>
<template>
  <div>
    <h1 class="page-title">
      <i class="fa-solid fa-box"></i><span class="space-icon"></span>
      {{ $t("labels.title") }}
    </h1>

    <div class="flex flex-row justify-end">
      <tabs-download-buttons-packing-list
        :container_code="container_code"
        :container_id="container_id"
      />
      <button
        type="button"
        @click.prevent="goToNewPackages()"
        class="btn-white"
      >
        <i class="fa-solid fa-plus"></i><span class="space-icon"></span
        >{{ $t("labels.new_button") }}
      </button>
    </div>
    <div class="mt-8 flex flex-col">
      <div class="table-first-container">
        <div class="table-second-container">
          <div class="table-third-container">
            <table class="table">
              <thead class="table-header">
                <tr>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.package.producer") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.package.exporter_process_crop_category") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.package.exporter_process_crop_variety") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.package.exporter_process_brand") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.package.exporter_process_crop_package") }}
                  </th>

                  <th
                    scope="col"
                    class="table-header-cell"
                    v-for="size in crop_sizes"
                    :key="size.id"
                  >
                    {{ size.name }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.package.package_group") }}
                  </th>
                  <th scope="col" class="table-header-cell"></th>
                </tr>
              </thead>
              <tbody class="table-body">
                <tr
                  class="table-row"
                  v-for="package_item in table_rows"
                  :key="package_item.id"
                >
                  <td class="table-cell-main">
                    {{ getProducerLabelByPackage(package_item) }}
                  </td>
                  <td class="table-cell">
                    {{
                      package_item.exporter_process_crop_category
                        .agro_exporter_crop_category.crop_category.name
                    }}
                  </td>
                  <td class="table-cell">
                    {{
                      package_item.exporter_process_crop_variety
                        .agro_exporter_crop_variety.crop_variety.name
                    }}
                  </td>
                  <td class="table-cell">
                    {{
                      package_item.exporter_process_brand.agro_exporter_brand
                        .name
                    }}
                  </td>
                  <td class="table-cell">
                    {{
                      $t("model.package.exporter_process_crop_package_value", {
                        name: package_item.exporter_process_crop_package.name,
                        weight:
                          package_item.exporter_process_crop_package
                            .gross_weight
                      })
                    }}
                  </td>
                  <td
                    scope="col"
                    v-for="size in crop_sizes"
                    :key="size.id"
                    class="table-cell"
                  >
                    {{
                      package_item.package_crop_sizes.find(
                        ps => ps.id == size.id
                      )?.quantity
                    }}
                  </td>
                  <td class="table-cell">
                    {{ package_item.package_group.pg_code }}
                  </td>
                  <td class="table-cell-action">
                    <a class="link" @click="goToEditPackages(package_item)"
                      ><i class="fa-solid fa-pen"></i
                      ><span class="space-icon"></span
                      >{{ $t("labels.edit_link") }}</a
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="py-6 text-right">
      <button type="button" @click.prevent="goToNewPackages" class="btn-white">
        <i class="fa-solid fa-plus pr-2"></i>
        {{ $t("labels.new_button") }}
      </button>
    </div>
  </div>
</template>

<script>
import TabsDownloadButtonsPackingList from "./DownloadButtonsPackingList.vue";

export default {
  name: "PackagesTab",
  components: { TabsDownloadButtonsPackingList },
  props: {
    package_groups: {
      type: Array,
      required: true
    },
    container_code: { required: true },
    agro_exporter_id: { required: true },
    agro_exporter_process_id: { required: true },
    container_id: { required: true },
  },
  computed: {
    crop_sizes: function () {
      let arr = [];
      this.packages.forEach(item => {
        if (
          arr.map(i => i.id).includes(item.exporter_process_crop_size.id) ==
          false
        ) {
          arr.push({
            id: item.exporter_process_crop_size.id,
            name: item.exporter_process_crop_size.agro_exporter_crop_size
              .crop_size.name
          });
        }
      });
      return arr.sort((a, b) => a.name.localeCompare(b.name));
    },
    packages: function () {
      let packages = [];
      this.package_groups.forEach(function (group) {
        packages = packages.concat(group.packages);
      });
      return packages;
    },
    table_rows: function () {
      var rows = [];
      this.packages.forEach(package_item => {
        let row = rows.find(row => this.findRow(row, package_item));

        let row_crop_size = {
          id: package_item.exporter_process_crop_size.id,
          quantity: package_item.quantity
        };
        if (row) {
          let find_package = row.package_crop_sizes.find(
            item => item.id == package_item.exporter_process_crop_size.id
          );

          if (find_package) find_package.quantity += package_item.quantity;
          else row.package_crop_sizes.push(row_crop_size);
        } else {
          rows.push({
            ...package_item,
            package_crop_sizes: [row_crop_size]
          });
        }
      });
      rows.sort((a, b) => this.sortByProviderAndPallet(a, b));
      return rows;
    }
  },

  methods: {
    findRow: function (row, package_item) {
      return (
        row.producer?.id == package_item.producer?.id &&
        row.organization?.id == package_item.organization?.id &&
        row.package_group_id == package_item.package_group_id &&
        row.exporter_process_crop_category.id ==
          package_item.exporter_process_crop_category.id &&
        row.exporter_process_crop_variety.id ==
          package_item.exporter_process_crop_variety.id &&
        row.exporter_process_crop_package.id ==
          package_item.exporter_process_crop_package.id &&
        row.exporter_process_brand.id == package_item.exporter_process_brand.id
      );
    },
    sortByProviderAndPallet: function (a, b) {
      let a_name = a.producer?.name || a.organization?.name;
      let b_name = b.producer?.name || b.organization?.name;
      return a_name.localeCompare(b_name) ||
        a.package_group.col_position > b.package_group.col_position
        ? a
        : b;
    },
    getPackageGroupById: function () {},
    getPackageGroupByPackage: function (package_item) {
      return this.getPackageGroupById(package_item.package_group_id);
    },
    getPGCodeByPackage: function (package_item) {
      let pg = this.getPackageGroupById(package_item.package_group_id);
      if (pg) return pg.pg_code;
      return "";
    },
    getProducerLabelByPackage: function (package_item) {
      if (package_item.producer && package_item.organization)
        return `${package_item.producer.name} (${package_item.organization.name})`;
      else if (package_item.producer) return package_item.producer.name;
      else if (package_item.organization) return package_item.organization.name;

      return "";
    },
    goToNewPackages: function () {
      this.$router.push({
        name: this.routeName("new_packages"),
        params: {
          agro_exporter_process_id: this.agro_exporter_process_id,
          container_id: this.container_id
        }
      });
    },
    goToEditPackages: function (package_item) {
      this.$router.push({
        name: this.routeName("edit_packages"),
        params: {
          agro_exporter_process_id: this.agro_exporter_process_id,
          container_id: this.container_id,
          producer_id: package_item.producer?.id,
          organization_id: package_item.organization?.id
        }
      });
    }
  }
};
</script>
